import { AddOns } from '../../../../../constants/add-ons';
import { USD } from '../../../../../constants/currency-codes';

/**
 * These addOns are special and need special accommodations. We do not act on them during our migration and must include their price when calculating our promo plan total
 * @constant
 */
export const LegacyAddOnsToPreserveThroughMigration = /** @type {Array<('DropShip' | 'FulfillmentProviderBundle')>} */ ([
  AddOns.DropShip,
  AddOns.FulfillmentProviderBundle,
]);

/** @typedef {import('./types.d.ts').Price} Price */

/**
 * Default value to display in the event that the data-driven shipmentLimitTiers aren't available
 * @constant {Price}
 */
export const FallbackPrice = {
  code: USD,
  pricingCode: 'PricingUnchanged',
  value: 0,
};

/**
 * Default value to display in the event the data-driven shipment volume limit isn't available
 * @constant {number}
 */
export const FallbackShipmentLimit = 0;
